module.exports = __webpack_public_path__ + "static/media/ARBITRUM.b4704d24.svg";